import { messages as globalMessages } from 'shared/global/messages';

import { messages } from './messages';

export const iconLabels = {
  close: globalMessages.close,
  back: globalMessages.back,
  delete: globalMessages.delete,
  download: globalMessages.download,
  moreActions: globalMessages.moreActions,
  edit: globalMessages.edit,
  remove: globalMessages.remove,
  add: globalMessages.add,
  preview: globalMessages.preview,
  copy: globalMessages.copy,
  clear: globalMessages.clear,
  cancel: globalMessages.cancel,
  search: globalMessages.search,
  calendar: globalMessages.calendar,
  sendEmail: globalMessages.sendEmail,
  sendSms: globalMessages.sendSms,
  exportToWx: globalMessages.exportToWx,
  reject: globalMessages.reject,
  addDataKey: globalMessages.addDataKey,
  duplicateApplicant: globalMessages.duplicateApplicant,
  emailUnsubscribed: globalMessages.emailUnsubscribed,
  smsUnsubscribed: globalMessages.smsUnsubscribed,
  ...messages,
};
